export function formatTime(date: Date | string) {
  return new Intl.DateTimeFormat('es-DO', { timeStyle: 'short' }).format(new Date(date));
}
